import { render, staticRenderFns } from "./sendinfo.vue?vue&type=template&id=5163e328&scoped=true"
import script from "./sendinfo.vue?vue&type=script&lang=js"
export * from "./sendinfo.vue?vue&type=script&lang=js"
import style0 from "./sendinfo.vue?vue&type=style&index=0&id=5163e328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163e328",
  null
  
)

export default component.exports